import { BasketItem } from '@aboutyou/backbone';
import sum from 'lodash/sum';
import { BasketResponse } from 'commerce/scayle/user-interaction/types';
import { Product } from 'commerce/scayle/utils/adapter';
import {
  DAILY_DEAL_PRODUCT_LABEL,
  FREE_PRODUCT_LABEL,
} from 'src/client/components/constants';

/***
 * Step 1: Sum all MoV Summable values:
 * Calculate the total of minimum_order_value_summable for all products in the cart where this attribute exists
 * Example: If products have MoV Summable = 29.99, 9.95, total = 39.94 €
 *
 * Step 2: Find the highest individual MoV:
 * Identify the largest minimum_order_value among all products in the cart
 * Example: If products have MoV = 29.99, 4.95, the highest = 29.99 €
 *
 * Step 3: Compare and select the greater value:
 * Required MoV = MAX(Sum of MoV Summable, Highest Individual MoV)
 * */
export const getMinimumOrderValue = (cart: BasketResponse): number => {
  if (!cart) {
    return 0;
  }

  const products = cart.items.map((item) =>
    Product.createCartProduct(item).toJSON(),
  );

  const minOrderValues = products.map(
    (product) => product.minimumOrderValue || 0,
  );

  const minOrderValueSum = sum(
    products.map((product) => product.minimumOrderValueSummable || 0),
  );

  return Math.max(...minOrderValues, minOrderValueSum);
};

export const hasFreeProducts = (cart: BasketResponse): boolean => {
  return cart?.items
    ?.map((item) => {
      const data = Product.createProduct(item.product);

      return data.label;
    })
    .includes(FREE_PRODUCT_LABEL);
};

export const hasDailyDealProducts = (cart: BasketResponse): boolean => {
  return cart?.items
    ?.map((item) => {
      const data = Product.createProduct(item.product);

      return data.label;
    })
    .includes(DAILY_DEAL_PRODUCT_LABEL);
};

export const hasOnlyProductsFromCategory = (
  categoryName: string,
  items?: BasketItem[],
) => {
  return (
    items?.every((item) =>
      item.product.categories?.some((category) =>
        category.some(
          (subCategory) => subCategory.categoryName === categoryName,
        ),
      ),
    ) || false
  );
};
